import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/Card';
import { factorCardsData } from 'sections/Resources/DemurrageAndDetention/data';
import { FactorCardType } from 'sections/Resources/DemurrageAndDetention/types';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionFactors/SectionFactors.module.scss';

const cn = classNames.bind(styles);

const SectionFactors = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const renderHeadingDescription = () => {
    if (screenWidth >= 769) {
      return (
        <>
          <span>Various factors, often interconnected, can lead to delays</span>{' '}
          <span>resulting in these unwanted charges.</span>
        </>
      );
    }
    if (screenWidth <= 768 && screenWidth >= 576) {
      return (
        <>
          <span>Various factors, often interconnected, can</span>{' '}
          <span>lead to delays resulting in these</span>{' '}
          <span>unwanted charges.</span>
        </>
      );
    }
    if (screenWidth <= 575) {
      return (
        <>
          <span>Various factors, often interconnected,</span>{' '}
          <span>can lead to delays resulting in these</span>{' '}
          <span>unwanted charges.</span>
        </>
      );
    }
  };

  const cardItems = factorCardsData.map((card: FactorCardType) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__heading-container')}>
            <div className={cn('card__heading-icon')}>
              <img
                src='/images/pages/Resources/DemurrageAndDetention/icon-file.svg'
                alt='file icon'
              />
            </div>
            <h3 className={cn('card__heading')}>{card.heading}</h3>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('factors')}>
      <div className={cn('container')}>

        <div className={cn('factors__heading-container')}>
          <h2 className={cn('factors__heading')}>
            <span>Factors Contributing</span>{' '}
            <span>to Demurrage and Detention</span>
          </h2>
          <p className={cn('factors__heading-description')}>
            {renderHeadingDescription()}
          </p>
        </div>

        <div className={cn('factors__cards')}>
          {cardItems}
        </div>

      </div>
    </section>
  );
};

export default SectionFactors;
